<template>
  <div class="spm-data-container" v-if="$store.state.spmDashboardFrom"> 
    <div class="spm-chart">
      <div
        class="d-flex justify-content-center align-items-center chartContainer"
      >
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
    <div class="spm-table">
      <b-table
        striped
        bordered
        no-border-collapse
        responsive
        :items="getItems"
        :fields="fields"
      >
        <template v-slot:thead-top>
          <b-tr>
            <b-th rowspan="3" class="bg-head text-tcenter">Vendor Category</b-th>
            <b-th colspan="4" class="bg-head text-tcenter">{{ $store.state.spmDashboardFrom }}</b-th>
            <b-th colspan="4" class="bg-head text-tcenter">{{ $store.state.spmDashboardFrom !== $store.state.spmDashboardTo ? $store.state.spmDashboardTo : '-' }}</b-th>
          </b-tr>
          <b-tr>
            <b-th colspan="2" class="bg-head text-tcenter">S1</b-th>
            <b-th colspan="2" class="bg-head text-tcenter">S2</b-th>
            <b-th colspan="2" class="bg-head text-tcenter">S1</b-th>
            <b-th colspan="2" class="bg-head text-tcenter">S2</b-th>
          </b-tr>
          <b-tr>
            <b-th class="bg-head text-tcenter">BCE</b-th>
            <b-th class="bg-head text-tcenter">GEMS</b-th>
            <b-th class="bg-head text-tcenter">BCE</b-th>
            <b-th class="bg-head text-tcenter">GEMS</b-th>
            <b-th class="bg-head text-tcenter">BCE</b-th>
            <b-th class="bg-head text-tcenter">GEMS</b-th>
            <b-th class="bg-head text-tcenter">BCE</b-th>
            <b-th class="bg-head text-tcenter">GEMS</b-th>
          </b-tr>
        </template>

        <template v-slot:table-colgroup>
			    <col
			      v-for="field in fields"
			      :key="field.key"
			      :rowspan="field.key == 'vendor_category' ? 2 : 1"
			    >
			  </template>


      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  name : 'SpmSummary',
  data() {
    return {
      fields : [
        { key : 'vendor_category', label : '', thClass : 'bg-none'},
        { key : 'bce_1_1', label : '', thClass : 'bg-none'},
        { key : 'gems_1_1', label : '', thClass : 'bg-none'},
        { key : 'bce_1_2', label : '', thClass : 'bg-none'},
        { key : 'gems_1_2', label : '', thClass : 'bg-none'},
        { key : 'bce_2_1', label : '', thClass : 'bg-none'},
        { key : 'gems_2_1', label : '', thClass : 'bg-none'},
        { key : 'bce_2_2', label : '', thClass : 'bg-none'},
        { key : 'gems_2_2', label : '', thClass : 'bg-none'},
      ],
      items : [
        { 
          vendor_category : 'Sangat Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Cukup Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Tidak Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Sangat Buruk', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
      ],
      chartOptions: {
        colors: ['#ffd34c', '#a0b376', '#10253f', '#d34c4c', '#ff4c4c'],
        chart: {
          height : '300',
          type: 'column'
        },
        title: {
            text: 'SPM Summary'
        },
        xAxis: {
            categories: [],
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Score'
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px"><strong>{point.key}</strong></span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [{
            name: 'Sangat Memuaskan',
            data: [],
        }, {
            name: 'Memuaskan',
            data: [],
        }, {
            name: 'Cukup Memuaskan',
            data: [],
        }, {
            name: 'Tidak Memuaskan',
            data: [],
        },{
            name: 'Sangat Buruk',
            data: [],
        }]
      },
    };
  },
  created(){
      this.chartCategories()
      // this.seriesData()
  },
  computed : {
    getItems : {
      get : function(){
        this.createTable()
        this.seriesData()
        this.chartCategories()
        return this.items
      }
    },
  },
  methods: {
    itemsBefore(){
      this.items = [
        { 
          vendor_category : 'Sangat Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Cukup Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Tidak Memuaskan', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
        { 
          vendor_category : 'Sangat Buruk', 
          bce_1_1 : 0,
          bce_1_2 : 0,
          bce_2_1 : 0,
          bce_2_2 : 0,
          gems_1_1 : 0,
          gems_1_2 : 0,
          gems_2_1 : 0,
          gems_2_2 : 0,
        },
      ]
    },
    createTable(){
      const self = this
      
      const summary = self.$store.state.spmDashboardSummary
      const yearFrom = self.$store.state.spmDashboardFrom
      const yearTo = self.$store.state.spmDashboardTo
      self.itemsBefore()
      summary && summary.forEach(list => {
        self.items.map(item => {
          if(list.YEAR == yearFrom && list.GRADE == item.vendor_category.toUpperCase()){
            item.bce_1_1 = list.SERVER == 'BERAU' && list.SEMESTER == 1 ? list.TOTAL : item.bce_1_1
            item.bce_1_2 = list.SERVER == 'BERAU' && list.SEMESTER == 2 ? list.TOTAL : item.bce_1_2
            item.gems_1_1 = list.SERVER == 'GEMS' && list.SEMESTER == 1 ? list.TOTAL : item.gems_1_1
            item.gems_1_2 = list.SERVER == 'GEMS' && list.SEMESTER == 2 ? list.TOTAL : item.gems_1_2
          }
          if(yearFrom !== yearTo && list.YEAR == yearTo && list.GRADE == item.vendor_category.toUpperCase()){
            item.bce_2_1 = list.SERVER == 'BERAU' && list.SEMESTER == 1 ? list.TOTAL : item.bce_2_1
            item.bce_2_2 = list.SERVER == 'BERAU' && list.SEMESTER == 2 ? list.TOTAL : item.bce_2_2
            item.gems_2_1 = list.SERVER == 'GEMS' && list.SEMESTER == 1 ? list.TOTAL : item.gems_2_1
            item.gems_2_2 = list.SERVER == 'GEMS' && list.SEMESTER == 2 ? list.TOTAL : item.gems_2_2
          }
        })
      })
    },
    chartCategories() {
      const self = this
      const yearFrom = self.$store.state.spmDashboardFrom
      const yearTo = self.$store.state.spmDashboardTo
      const dateFormat =  { day: 'numeric', month: 'short', year: 'numeric' }
      self.chartOptions.xAxis.categories = [
        `S1 ${yearFrom} BCE`, 
        `S1 ${yearFrom} GEMS`, 
        `S2 ${yearFrom} BCE`, 
        `S2 ${yearFrom} GEMS`,
        `S1 ${yearTo} BCE`, 
        `S1 ${yearTo} GEMS`, 
        `S2 ${yearTo} BCE`, 
        `S2 ${yearTo} GEMS`]
    },
    seriesData() {
      const self = this
      const items = self.items
      const summary = self.$store.state.spmDashboardSummary
      const yearFrom = self.$store.state.spmDashboardFrom
      const yearTo = self.$store.state.spmDashboardTo

      let series0 = []
      let series1 = []
      let series2 = []
      let series3 = []
      let series4 = []

      for(let i in items){
        self.chartOptions.series[i].data = [items[i].bce_1_1, items[i].gems_1_1, items[i].bce_1_2, items[i].gems_1_2, items[i].bce_2_1, items[i].gems_2_1, items[i].bce_2_2, items[i].gems_2_2]
        // if(i == 0){
        //   series0 = [items[i].bce_1_1, items[i].gems_1_1, items[i].bce_1_2, items[i].gems_1_2, items[i].bce_2_1, items[i].gems_2_1, items[i].bce_2_2, items[i].gems_2_2]
        // }
      }

    },
  },
};
</script>
<style lang="scss">
  @import "~/assets/scss/components/dashboard.scss";
</style>
